import {
  EXPORT_DEMAND,
  PUBLISH_DEMAND,
  SEARCH_ADDRESS_GET,
  SEARCH_COORDINATE_FOR_ADDRESS_GET,
  SEARCH_COORDINATE_GET,
  SEARCH_MILEAGE_GET,
  SEARCH_OBJECTS_WFS_GET,
  SEARCH_ROAD_GET,
  SEARCH_TERYT_GET,
  SEARCH_TERYTPARCEL_GET
} from './actions.type';

import {
  SEARCH_ADDRESS_SET_SELECTED_OBJECT,
  SEARCH_COORDINATE_SET_RESULT,
  SEARCH_ADDRESS_SET_RADIUS,
  SEARCH_ADDRESS_SET_GEOMETRY_SEARCH_RADIUS,
  SEARCH_LOADER_HIDE,
  SEARCH_LOADER_SHOW,
  SEARCH_RESULTS_LOADER_SHOW,
  SEARCH_RESULTS_LOADER_HIDE,
  SEARCH_MILEAGE_SET_RESULT,
  SEARCH_PANEL_SET_ITEMS,
  SEARCH_PANEL_TOGGLE_VISIBILITY,
  SEARCH_TERYT_PARCEL_SET_RESULT,
  SEARCH_TERYT_SET_RESULT,
  SEARCH_WFS_SET_RESULT,
  WINDOW_API_ERROR_SHOW,
  WINDOW_NOTIFICATION_SHOW,
  SEARCH_MODE_BY_POINT_ENABLE,
  SEARCH_MODE_BY_RECTANGLE_ENABLE,
  SEARCH_MODE_BY_POLYGON_ENABLE,
  SEARCH_MODE_BY_GEOMETRY_DISABLE,
  SET_FEATURES_WITH_COORDINATES
} from './mutations.type';

import { Api as SearchApi } from '../api/api-wyszukiwarka';
import { Api as CustomApi } from '../api/custom-api';
import { Api as DemandApi } from '../api/api-zglaszanie-popytu';
import { getArea, getLength } from 'ol/sphere.js';
const searchApi = new SearchApi();
const customApi = new CustomApi();
const demandApi = new DemandApi();

const initialState = {
  selectedAddressSearchItem: undefined,
  mileageSearchResultObject: undefined,
  terytSearchResultObject: undefined,
  terytParcelSearchResultObject: undefined,
  coordinateSearchResultObject: undefined,
  wfsSearchResultObject: undefined,
  searchLoading: false,
  searchResultsLoading: false,
  searchPanelVisible: false,
  searchLayersItems: [],
  searchSquareKmMax: 1,
  selectedSearchRadius: 0,
  selectedSearchByGeometryRadius: 0,
  searchModuleByPoint: false,
  searchModuleByRectangle: false,
  searchModuleByPolygon: false,
  featuresWithCoordinates: undefined
};

export const state = Object.assign({}, initialState);

export const actions = {
  async [SEARCH_MILEAGE_GET](context, mileageSearchObject) {
    try {
      context.commit(SEARCH_LOADER_SHOW);
      var control = Date.now();
      var result = await searchApi.getWyszukiwarkaKilometraz({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        control: control,
        road_number: mileageSearchObject.mileageRoadNumber,
        mileage: mileageSearchObject.mileageValue
      });

      if (result && result.body.control == control.toString()) {
        context.commit(SEARCH_MILEAGE_SET_RESULT, result.body.kilometraz);
        context.commit(SEARCH_LOADER_HIDE);
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
      context.commit(SEARCH_LOADER_HIDE);
    }
  },
  async [SEARCH_TERYT_GET](context, terytSearchObject) {
    try {
      context.commit(SEARCH_LOADER_SHOW);
      var control = Date.now();
      var result = await searchApi.getWyszukiwarkaDzialkiEwidencyjne({
        powiat: terytSearchObject.district.nazwa,
        gmina: terytSearchObject.commune.nazwa,
        obreb:
          terytSearchObject.perimeter != null
            ? terytSearchObject.perimeter
            : '',
        numer: terytSearchObject.parcelNumber,
        control: control
      });
      if (result && result.body.control == control.toString()) {
        context.commit(
          SEARCH_TERYT_SET_RESULT,
          result.body.dzialki_ewidencyjne
        );
        context.commit(SEARCH_LOADER_HIDE);
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
      context.commit(SEARCH_LOADER_HIDE);
    }
  },
  async [SEARCH_TERYTPARCEL_GET](context, object) {
    // try {
    context.commit(SEARCH_LOADER_SHOW);
    var result = await customApi.getAggregateArea({
      id: object.terytSearchObject
    });
    if (result) {
      if (!result.body) {
        // throw new Error('Nie udało się pobrać geometrii działki/działek.');
      }
      if (result.body.includes('brak wyników')) {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga',
          message: `Dla wybranej działki ${object.terytSearchObject} usługa uldk.gugik.gov.pl nie zwraca wyników wyszukiwania - może to być spowodowane podaniem nieprawidłowego numeru działki lub chwilowymi problemami usługi. Upewnij się, że numer jest prawidłowy lub spróbuj później.`,
          duration: 5000,
          changedDuration: 10000
        });
      }

      let splittedResponse = result.body.split('\n').filter(x => !!x);
      if (splittedResponse.length < 2) {
        throw new Error(
          'Niepoprawny format pobranej geometrii działki/działek.'
        );
      }

      splittedResponse = splittedResponse.splice(
        1,
        splittedResponse.length - 1
      );
      //Remove not unnecessary chars;

      splittedResponse.forEach((element, index) => {
        splittedResponse[index] = element.substring(
          element.indexOf('POLYGON'),
          element.length + 1
        );
      });

      splittedResponse.forEach((element, index) => {
        if (element.includes(';')) {
          element = element.split(';');
          splittedResponse[index] = element[0];
        }
      });
      if (splittedResponse[0] === splittedResponse[1]) {
        splittedResponse.splice(1, 1);
      }
      //Fixing if polygons are in one array

      (function splitPoligons() {
        let rawPointsStr = splittedResponse[0].substring(
          splittedResponse[0].indexOf('(') + 1,
          splittedResponse[0].lastIndexOf(')')
        );
        let rawPointsArr = [];
        rawPointsArr.push(rawPointsStr.slice(0, rawPointsStr.indexOf(')') + 1));
        rawPointsStr = rawPointsStr.substring(
          rawPointsArr[rawPointsArr.length - 1].length + 1
        );
        splittedResponse[rawPointsArr.length - 1] =
          splittedResponse[0].substring(
            0,
            splittedResponse[0].indexOf('(') + 1
          ) +
          rawPointsArr[rawPointsArr.length - 1] +
          ')';
        if (rawPointsStr.length > 1 && rawPointsStr.includes(')')) {
          splitPoligons();
        }
      })();

      //Fixing if polygon is open
      (function fixingOpenPolygon() {
        const firstPoint = splittedResponse[0].substring(
          splittedResponse[0].indexOf('((') + 2,
          splittedResponse[0].indexOf(',')
        );
        const lastPoint = splittedResponse[0].substring(
          splittedResponse[0].lastIndexOf(',') + 1,
          splittedResponse[0].lastIndexOf('))')
        );
        if (firstPoint.replace(/\s/g, '') !== lastPoint.replace(/\s/g, '')) {
          splittedResponse[0] = splittedResponse[0].replace(
            '))',
            `,${firstPoint}))`
          );
        }
      })();

      context.commit(SEARCH_TERYT_PARCEL_SET_RESULT, {
        parcelNumber: object.parcelNumber,
        searchObject: splittedResponse
      });
      context.commit(SEARCH_LOADER_HIDE);
    }
    // } catch (error) {
    //   context.commit(WINDOW_API_ERROR_SHOW, error);
    //   context.commit(SEARCH_LOADER_HIDE);
    // }
  },
  async [SEARCH_ROAD_GET](context, roadSearchObject) {
    try {
      var result = await searchApi.getWyszukiwarkaDrogi({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        road_number: roadSearchObject.text,
        control: roadSearchObject.control
      });
      if (result) {
        return result.body;
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [SEARCH_ADDRESS_GET](context, addressSearchObject) {
    try {
      var result = await searchApi.getWyszukiwarkaAdres({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        adres: addressSearchObject.text,
        control: addressSearchObject.control
      });
      if (result) {
        return result.body;
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [SEARCH_COORDINATE_FOR_ADDRESS_GET](context, searchAddress) {
    try {
      var result = await customApi.getCoordinationsForAdress(searchAddress, {
        ignoreGlobalErrors: true
      });
      if (result) {
        return result.body;
      }
    } catch (error) {
      var errorMsg = 'Usługa wyszukiwania jest czasowo niedostępna';
      context.commit(WINDOW_API_ERROR_SHOW, errorMsg);
    }
  },
  async [PUBLISH_DEMAND](context, demand) {
    try {
      var result = await customApi.publishDemand(demand);
      if (result) {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'success',
          title: 'Sukces',
          message: 'Zgłoszenie popytu zostało poprawnie zapisane.'
        });
        return result.body;
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [EXPORT_DEMAND](context, target) {
    try {
      await demandApi.exportDemandToFile(target, {
        ignoreGlobalError: true,
        download: true,
        withCredentials: false,
        jsonData: true
      });
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [SEARCH_COORDINATE_GET](context, coordinateSearchObject) {
    try {
      context.commit(SEARCH_LOADER_SHOW);
      var control = Date.now();
      var result = await searchApi.getWyszukiwarkaObiektWspolrzedne({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        coords_system: coordinateSearchObject.coordinateSystem,
        x: coordinateSearchObject.X,
        y: coordinateSearchObject.Y,
        tolerance: coordinateSearchObject.tolerance,
        active_layer: coordinateSearchObject.activeLayerId,
        control: control
      });
      if (result && result.body.control == control.toString()) {
        context.commit(SEARCH_COORDINATE_SET_RESULT, {
          result: result.body.feature_ids,
          searchObject: coordinateSearchObject
        });
        context.commit(SEARCH_LOADER_HIDE);
      }
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
      context.commit(SEARCH_LOADER_HIDE);
    }
  },
  async [SEARCH_OBJECTS_WFS_GET](context, parameters) {
    context.commit(SEARCH_RESULTS_LOADER_SHOW);
    context.commit(SEARCH_PANEL_SET_ITEMS, []);
    let wfsLayersItems = [];
    async function processAndOptimizeFeatures(layersFeatures, context) {
      const tableMeta = context.rootGetters.tableMeta;
      const processedWfsLayersItems = [];

      layersFeatures.forEach(layerFeatures => {
        layerFeatures.layerName = layerFeatures.layerName || 'uslugi_pkt_adr';
        const featureTableMeta = tableMeta.find(table => {
          return table.nazwa == layerFeatures.layerName;
        });
        let wfsLayer = {
          items: []
        };
        if (layerFeatures.features) {
          layerFeatures.features.forEach(feature => {
            let wfsObj = {
              propertiesList: {}
            };
            for (let property in feature.properties) {
              if (feature.properties[property]) {
                let column = null;
                if (featureTableMeta) {
                  column = featureTableMeta.kolumny.find((kolumna, index) => {
                    return kolumna.nazwa === property;
                  });
                }
                if (column) {
                  let value = feature.properties[property];
                  if (column.slownik == 1) {
                    const dictionary = context.getters.dictionaries.find(
                      dictionary => {
                        return dictionary.nazwa == column.nazwa_slownika;
                      }
                    );

                    if (dictionary) {
                      const foundValue = dictionary.pola.find(pole => {
                        return pole.value == value;
                      });
                      // window.console.log(dictionary);
                      // window.console.log(value);
                      // window.console.log(foundValue);
                      if (foundValue) {
                        value = foundValue.hint || foundValue.value;
                      }
                    }
                  } else if (column.slownik == 3) {
                    if (value == 1 || value == 2) {
                      value = 'Tak';
                    } else if (value === 0) {
                      value = 'Nie';
                    }
                  }

                  wfsObj.propertiesList[column.etykieta] = value;
                } else {
                  wfsObj.propertiesList[property] = value;
                }
              }
            }
            wfsObj.coordinates = feature.geometry.coordinates || [];
            wfsLayer.items.push(wfsObj);
          });
        }

        processedWfsLayersItems.push({
          ...wfsLayer,
          layerName: featureTableMeta
            ? featureTableMeta.etykieta
            : layerFeatures.layerName
        });
      });

      return processedWfsLayersItems;
    }
    const processAndCommitFeatures = async (features, context) => {
      if (features && features.body) {
        const layersFeatures = Array.isArray(features.body)
          ? features.body
          : [features.body];
        const combinedFeatures = layersFeatures.reduce((result, layer) => {
          if (layer.features) {
            result.push(...layer.features);
          }
          return result;
        }, []);
        context.commit(SET_FEATURES_WITH_COORDINATES, combinedFeatures);

        const wfsItems = await processAndOptimizeFeatures(
          layersFeatures,
          context
        );
        wfsLayersItems.push(...wfsItems);
      } else {
        context.commit(SET_FEATURES_WITH_COORDINATES, []);
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga',
          message: 'Brak danych o usługach dla wybranego adresu.'
        });
      }
    };

    if (parameters.point) {
      const requestParameters = {
        wso2_id: parameters.context.contextEmail,
        orgid: parameters.context.contextOrganizationId,
        body: {
          x: parameters.point.x,
          y: parameters.point.y,
          radius: parameters.radius * 1000
        }
      };
      const api = searchApi;
      const result = await api.getFeaturesInRadius(requestParameters);
      await processAndCommitFeatures(result, context);
    }

    if (parameters.address) {
      const requestParameters = {
        wso2_id: parameters.context.contextEmail,
        orgid: parameters.context.contextOrganizationId,
        body: {
          simc: parameters.address.simc,
          terc: parameters.address.terc,
          ulic: parameters.address.ulic,
          number: parameters.address.number,
          x: parameters.address.x,
          y: parameters.address.y
        }
      };
      const api = searchApi;
      const result = await api.getUslugiPktAdresowe(requestParameters);
      await processAndCommitFeatures(result, context);
    }
    if (state.searchModuleByRectangle || state.searchModuleByPolygon) {
      const formattedCoordinates = parameters.polygon[0]
        .map(coord => `${coord[0]} ${coord[1]}`)
        .join(', ');
      const formattedPolygon = `Polygon((${formattedCoordinates}))`;

      const requestParameters = {
        wso2_id: parameters.context.contextEmail,
        orgid: parameters.context.contextOrganizationId,
        body: {
          shape: formattedPolygon
        }
      };
      const api = searchApi;
      const result = await api.getLayerInPolygon(requestParameters);
      await processAndCommitFeatures(result, context);
    }

    context.commit(SEARCH_PANEL_SET_ITEMS, wfsLayersItems);
    context.commit(SEARCH_RESULTS_LOADER_HIDE);
  }
};

export const mutations = {
  [SEARCH_ADDRESS_SET_SELECTED_OBJECT](state, searchResultObject) {
    state.selectedAddressSearchItem = searchResultObject;
  },
  [SEARCH_MILEAGE_SET_RESULT](state, searchResultObject) {
    state.mileageSearchResultObject = searchResultObject;
  },
  [SEARCH_TERYT_SET_RESULT](state, searchResultObject) {
    state.terytSearchResultObject = searchResultObject;
  },
  [SEARCH_TERYT_PARCEL_SET_RESULT](state, searchResultObject) {
    state.terytParcelSearchResultObject = searchResultObject;
  },
  [SEARCH_COORDINATE_SET_RESULT](state, searchResultObject) {
    state.coordinateSearchResultObject = searchResultObject;
  },
  [SEARCH_MODE_BY_POINT_ENABLE](state) {
    state.searchModuleByRectangle = false;
    state.searchModuleByPolygon = false;
    state.searchModuleByPoint = true;
  },
  [SEARCH_MODE_BY_RECTANGLE_ENABLE](state) {
    state.searchModuleByPolygon = false;
    state.searchModuleByPoint = false;
    state.searchModuleByRectangle = true;
  },
  [SEARCH_MODE_BY_POLYGON_ENABLE](state) {
    state.searchModuleByRectangle = false;
    state.searchModuleByPoint = false;
    state.searchModuleByPolygon = true;
  },
  [SEARCH_MODE_BY_GEOMETRY_DISABLE](state) {
    state.searchModuleByRectangle = false;
    state.searchModuleByPoint = false;
    state.searchModuleByPolygon = false;
  },
  [SEARCH_ADDRESS_SET_RADIUS](state, selectedSearchRadius) {
    state.selectedSearchRadius = selectedSearchRadius;
  },
  [SEARCH_ADDRESS_SET_GEOMETRY_SEARCH_RADIUS](
    state,
    selectedSearchByGeometryRadius
  ) {
    state.selectedSearchByGeometryRadius = selectedSearchByGeometryRadius;
  },
  [SEARCH_WFS_SET_RESULT](state, searchResultObject) {
    state.wfsSearchResultObject = searchResultObject;
  },
  [SEARCH_LOADER_SHOW](state) {
    state.searchLoading = true;
  },
  [SEARCH_LOADER_HIDE](state) {
    state.searchLoading = false;
  },
  [SEARCH_RESULTS_LOADER_SHOW](state) {
    state.searchResultsLoading = true;
  },
  [SEARCH_RESULTS_LOADER_HIDE](state) {
    state.searchResultsLoading = false;
  },
  [SEARCH_PANEL_TOGGLE_VISIBILITY](state) {
    state.searchPanelVisible = !state.searchPanelVisible;
  },
  [SEARCH_PANEL_SET_ITEMS](state, value) {
    state.searchLayersItems = value || [];
  },
  [SET_FEATURES_WITH_COORDINATES](state, featuresWithCoordinates) {
    state.featuresWithCoordinates = featuresWithCoordinates;
  }
};

export const getters = {
  selectedAddressSearchItem(state) {
    return state.selectedAddressSearchItem;
  },
  mileageSearchResultObject(state) {
    return state.mileageSearchResultObject;
  },
  terytSearchResultObject(state) {
    return state.terytSearchResultObject;
  },
  terytParcelSearchResultObject(state) {
    return state.terytParcelSearchResultObject;
  },
  coordinateSearchResultObject(state) {
    return state.coordinateSearchResultObject;
  },
  wfsSearchResultObject(state) {
    return state.wfsSearchResultObject;
  },
  searchSquareKmMax(state) {
    return state.searchSquareKmMax;
  },
  selectedSearchRadius(state) {
    return state.selectedSearchRadius;
  },
  selectedSearchByGeometryRadius(state) {
    return state.selectedSearchByGeometryRadius;
  },
  searchLoading(state) {
    return state.searchLoading;
  },
  searchResultsLoading(state) {
    return state.searchResultsLoading;
  },
  searchPanelVisible(state) {
    return state.searchPanelVisible;
  },
  searchLayersItems(state) {
    return state.searchLayersItems;
  },
  searchModuleByPoint(state) {
    return state.searchModuleByPoint;
  },
  searchModuleByRectangle(state) {
    return state.searchModuleByRectangle;
  },
  searchModuleByPolygon(state) {
    return state.searchModuleByPolygon;
  },
  featuresWithCoordinates(state) {
    return state.featuresWithCoordinates;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
